import Vue from 'vue'
import Vuex from 'vuex'
import env from './env'
import auth from './auth'
import master from './master'
import register from './register'
import cart from './cart'
import cartTracking from './cartTracking'
import subscription from './subscription'
import menu from './menu'
import addressUpsert from './addressUpsert'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    master,
    register,
    cart,
    cartTracking,
    subscription,
    env,
    menu,
    addressUpsert,
  },
})
